import React, { useState, useRef, useEffect } from "react";
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import CheckButton from "react-validation/build/button";
import { Link } from "react-router-dom";
import logo from "../image/atmos-logo.jpg";

import AuthService from "../services/auth.service";

const required = (value) => {
  if (!value) {
    return (
      <div className="alert alert-danger" role="alert">
        This field is required!
      </div>
    );
  }
};

const ResetPassword = (props) => {
  const form = useRef();
  const checkBtn = useRef();

  const [username, setUsername] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  var isAuth = localStorage.getItem("user");

  useEffect(() => {
    if (isAuth) {
      props.history.push("/atmos/");
      window.location.reload();
    }
  });

  const onChangeUsername = (e) => {
    const username = e.target.value;
    setUsername(username);
  };

  const handleReset = (e) => {
    e.preventDefault();

    setMessage("");
    setLoading(true);

    form.current.validateAll();

    if (checkBtn.current.context._errors.length === 0) {
      AuthService.resetpassword(username).then(
        // () => {
        //   props.history.push("/atmos/");
        //   window.location.reload();
        // },
        (error) => {
          const resMessage =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();

          setLoading(false);
          setMessage(resMessage);
          // console.log("error.message", error.message);
          // console.log("message", message);
        }
      );
    } else {
      setLoading(false);
    }
  };

  return (
    <div className="container-fluid bgimage height-100">
      <div className="col-md-12">
        <div className="card card-container">
          <img src={logo} alt="profile-img" className="profile-img-card" />

          <Form onSubmit={handleReset} ref={form}>
            <div className="form-group">
              <label htmlFor="username">
                <b>Username</b>
              </label>
              <Input
                type="text"
                className="form-control-input"
                name="username"
                value={username}
                placeholder="xxxxx@urbansciences.in"
                onChange={onChangeUsername}
                validations={[required]}
              />
            </div>

            <div className="form-group">
              <button className="button" disabled={loading}>
                {loading && (
                  <span className="spinner-border spinner-border-sm"></span>
                )}
                <span>Password Reset</span>
              </button>
            </div>
            <div className="form-group float-right">
              <Link to={"/atmos/login"}>
                <small className="black">Back to Login</small>
              </Link>
            </div>

            {message && (
              <div className="form-group">
                <div className="alert alert-danger" role="alert">
                  {message}
                </div>
              </div>
            )}
            <CheckButton style={{ display: "none" }} ref={checkBtn} />
          </Form>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
